// Оптимистичное обновление события при клике «Хочу пойти» / «Я иду»:
// счётчик, статус и аватары участников меняются сразу, до ответа сервера.

// Пресайн-ссылки на одно и то же фото содержат разные подписи в query-параметрах,
// поэтому сравниваем фото по ключу — части ссылки без query
const photoKey = (url) => (typeof url === 'string' ? url.split('?')[0] : url);

// joinUsers — первые три аватара участников; свой аватар всегда первым
export function optimisticToggleJoin(event, willJoin, ownAvatarUrl) {
  const avatars = event.joinUsers || [];
  let joinUsers = avatars;
  let myJoinIndex = event.myJoinIndex ?? -1;

  if (willJoin && ownAvatarUrl) {
    // Себя ставим в начало (как и сервер); лишнее за пределами трёх — срезаем
    const withoutMe = avatars.filter((url) => photoKey(url) !== photoKey(ownAvatarUrl));
    joinUsers = [ownAvatarUrl, ...withoutMe].slice(0, 3);
    myJoinIndex = 0;
  } else if (!willJoin && ownAvatarUrl) {
    const ownKey = photoKey(ownAvatarUrl);
    joinUsers = avatars.filter((url) => photoKey(url) !== ownKey);
    myJoinIndex = -1;
  }

  return {
    ...event,
    isJoined: willJoin,
    joins: Math.max(0, (event.joins || 0) + (willJoin ? 1 : -1)),
    joinUsers,
    myJoinIndex
  };
}
